import React, { useEffect, useState } from "react";
import "./PackageList.css";
import {
  DateRangePicker,
  Package,
  SortInput,
  TravelerSelector,
  RangeCalendar,
  ComingSoon,
  NotFound,
} from "../../../../components";
import { useNavigate } from "react-router-dom";
import { Modal, Form } from "react-bootstrap";
import Chip from "@mui/material/Chip";
import { axiosDelete, axiosGet, axiosPost } from "../../../../utils/apis/api";
import { TextField, Autocomplete } from "@mui/material";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Paginations, SpinnerLoading } from "../../../../components/index";
import dayjs from "dayjs";
import { useTranslation } from "../../../../contexts/TranslationContext";
import GlobalModal from "../AddModal/GlobalModal";

const PackageList = ({ packageData, setPackageData, url }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const resultsPerPage = 10;
  const [errors, setErrors] = useState({});
  const [debouncedTerm, setDebouncedTerm] = useState(null);
  const [searchTerm, setSearchTerm] = useState(null);
  const [sortOrder, setSortOrder] = useState("Newest to Oldest");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedRange, setSelectedRange] = useState(null);
  const [open, setOpen] = useState(false);
  const [hasMorelocations, setHasMorelocations] = useState(true);
  const [locations, setLocations] = useState(null);
  const PAGE_LIMIT = 50;
  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language") || "en";
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [nameValue, setNameValue] = useState(null);

  const [apiError, setApiError] = useState(null);
  const [errorData, setErrorData] = useState({
    code: "",
    message: "",
    description: "",
  });

  const goToDetails = (name) => {
    navigate(`/myPackages/${name}`);
  };

  useEffect(() => {
    // fetchLocations();
    // fetchMyPackages();
  }, []);

  useEffect(() => {
    if (sortOrder) {
      setData([]);
      setCurrentPage(0);
      setTotalPages(0);
      fetchMyPackages();
    }
  }, [sortOrder]);

  useEffect(() => {
    if (!open) {
      setPackageData({
        packageName: "",
        countries: [],
        travelers: {
          adults: 1,
          children: 0,
          children_ages: [],
        },
        startDate: "",
        endDate: "",
      });
      setErrors({});
      setNameValue(null);
    }
  }, [open]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedTerm(searchTerm); // Delay 500ms after writing stops
    }, 600);

    return () => clearTimeout(timer); // Cancel the timer if the user changes the text quickly
  }, [searchTerm]);

  useEffect(() => {
    if (!debouncedTerm && searchTerm == null) {
      return;
    }
    setData([]);
    setCurrentPage(0);
    setTotalPages(0);
    fetchMyPackages();
  }, [debouncedTerm]);

  useEffect(() => {
    if (selectedRange) {
      setData([]);
      setCurrentPage(0);
      setTotalPages(0);
      fetchMyPackages();
    }
  }, [selectedRange]);

  const handleDateChange = ({ startDate, endDate }) => {
    setSelectedRange({ startDate, endDate });
  };

  // Open/close the modal
  const handleOpen = () => {
    fetchLocations();
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  // Handle text inputs
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setPackageData((prev) => ({ ...prev, [name]: value }));
  // };

  const handleBlur = () => {
    // Update global state only when user leaves the input
    setPackageData((prev) => ({
      ...prev,
      packageName: nameValue,
    }));
  };
  const handleCountrySelect = (event, newValue) => {
    // setPackageData((prev) => ({
    //   ...prev,
    //   countries: newValue,
    // }));
    setPackageData((prev) => {
      const current = prev.countries || [];
  
      const updatedCountries = [];
  
      // Add if not already selected
      newValue.forEach((item) => {
        const exists = current.some(
          (c) => c.name === item.name
        );
        if (!exists) {
          updatedCountries.push(item);
        }
      });
  
      // Remove items that were unselected (i.e., not in newValue)
      const stillSelected = current.filter((item) =>
        newValue.some((val) => val.name === item.name)
      );
  
      return {
        ...prev,
        countries: [...stillSelected, ...updatedCountries],
      };
    });
  };
  // Remove a selected country chip
  const handleDelete = (countryToDelete) => {
    setPackageData((prev) => ({
      ...prev,
      countries: prev.countries.filter(
        (country) => country.name !== countryToDelete
      ),
    }));
  };

  const fetchLocations = async (search, newStart = 0, append = false) => {
    if (!hasMorelocations && append) return; // Stop if no more items
    // setLoading(true);
    try {
      var parameters = {
        start: newStart,
        limit: PAGE_LIMIT,
      };
      if (search) {
        parameters["search"] = search;
      }

      const response = await axiosGet(
        `${url}/api/method/alltimes.www.api.locations`,
        parameters
      );
      const newItems = Array.isArray(response.result?.locations)
        ? response.result?.locations
        : []; // Ensure array
      setLocations((prevItems) =>
        append ? [...prevItems, ...newItems] : newItems
      );
      setHasMorelocations(newItems.length === PAGE_LIMIT);
      // setStart(newStart + PAGE_LIMIT);
    } catch (error) {
      console.error("Error fetching destinations:", error);
      setLocations([]); // Ensure items is always an array
    } finally {
      // setLoading(false);
    }
  };

  const fetchMyPackages = async (pageNumber = 1) => {
    try {
      setIsLoading(true);

      setApiError(null);

      const start = (pageNumber - 1) * resultsPerPage;
      let apiUrl = `${url}/api/method/erpnext.selling.doctype.quotation.quotation.PackageQuotation?start=${start}&limit=${resultsPerPage}`;

      if (searchTerm) {
        apiUrl += `&search=${searchTerm}`;
      }
      if (sortOrder) {
        if (sortOrder === "Oldest to Newest") {
          apiUrl += `&order_by=creation&ordering=asc`;
        } else {
          apiUrl += `&order_by=creation&ordering=desc`;
        }
      }
      if (selectedRange) {
        if (selectedRange.startDate) {
          apiUrl += `&start_date=${dayjs(selectedRange.startDate).format(
            "YYYY-MM-DD HH:mm:ss"
          )}`;
        }
        if (selectedRange.endDate) {
          apiUrl += `&end_date=${dayjs(selectedRange.endDate).format(
            "YYYY-MM-DD HH:mm:ss"
          )}`;
        }
      }
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const response = await axiosGet(apiUrl, {}, headers);

      if (response.error) {
        // Handle API errors
        const errorCode = response.error.code || "500";
        const errorMsg = response.error.message || t("UnknownError");

        setErrorData({
          code: errorCode,
          message: errorMsg,
          description: t("PackageFetchError"),
        });
        setApiError(true);
        setData([]);
      } else {
        // Process successful response
        const result = response.result;
        setData(result.quotations || []);
        setCurrentPage(result?.pagination?.metadata?.current_page ?? 0);
        setTotalPages(result?.pagination?.metadata?.total_pages ?? 0);
      }
    } catch (error) {
      setErrorData({
        code: error.response?.status || 500,
        message: error.message || t("anErrorOccurred"),
        description: t("PackageFetchError"),
      });
      setApiError(true);

      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const onPageChange = (pageNumber) => {
    fetchMyPackages(pageNumber);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (
      !packageData.packageName ||
      !packageData.packageName.trim() ||
      !nameValue
    ) {
      newErrors.packageName = t("PackageNameRequired");
    }
    if (packageData.countries.length === 0) {
      newErrors.countries = t("PackageCountriesRequired");
    }
    if (!packageData.startDate || !packageData.endDate) {
      newErrors.date = t("PackageDateRequired");
    }

    if (
      packageData.travelers.children > 0 &&
      (packageData.travelers.children_ages.length <
        packageData.travelers.children ||
        packageData.travelers.children_ages.includes(null) ||
        packageData.travelers.children_ages.includes(0))
    ) {
      newErrors.childrenAges = t("PackageChildrenAgesRequired");
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // No errors: proceed with submission
    setErrors({});

    setLoading(true);

    var quot_destination = packageData.countries.map((country) => ({
      location: country.name,
    }));

    const payload = {
      package_name: packageData.packageName,
      destinations: quot_destination,
      start_date: packageData.startDate,
      end_date: packageData.endDate,
      travelers: packageData.travelers,
    };

    try {
      // 1. Create the package
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const packageResponse = await axiosPost(
        `${url}/api/method/erpnext.selling.doctype.quotation.quotation.PackageQuotation`,
        payload,
        headers
      );

      if (packageResponse.status !== 200)
        toast.error(
          t("ErrorOccurredWhileAddingPackage"),
          {
            position: "bottom-right",
          }
        );
      const packageData = packageResponse.data;
      // const docname = packageName; // Adjust based on API response if needed
      setPackageData((prev) => ({
        ...prev,
        "package_name": packageData.message.name,
      }));
      toast.success("Package Added!", {
        position: "bottom-right",
      });
      setLoading(false);
      handleClose();
      setNameValue(null);
      goToDetails(packageData.message.name);
      // onStartPlanning();
    } catch (error) {
      toast.error(
        error?.message ??
          t("ErrorOccurredWhileAddingPackage"),
        {
          position: "bottom-right",
        }
      );
      setLoading(false);
      console.error("Error:", error);
    }
  };

  const deletePackage = async (package_id) => {
    setIsLoading(true);
    setDeleteModal(false);
    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };

      var response = await axiosDelete(
        `${url}/api/method/erpnext.selling.doctype.quotation.quotation.PackageQuotation?quotation_id=${package_id}`,
        headers
      );

      if (response.status === 200) {
        toast.success(t("YourPackageDeleted"), {
          position: "bottom-right",
        });
        setDeleteId(null);
        fetchMyPackages();
      } else {
        toast.error(
          response.message ?? t("ErrorOccurredWhileDeletingPackage"),
          {
            position: "bottom-right",
          }
        );
        setIsLoading(false);
        setDeleteId(null);
      }
    } catch (error) {
      toast.error(error.toString() ?? t("ErrorOccurredWhileDeletingPackage"), {
        position: "bottom-right",
      });
      setIsLoading(false);
      setDeleteModal(false);
      setDeleteId(null);
    }
  };

  return (
    <div className="package-list-container">
      <div className="package-list-header">
        <input
          type="search"
          className="package-list-search"
          placeholder={t("Search")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div className="package-list-filters">
          <RangeCalendar value={selectedRange} onChange={handleDateChange} />
          <SortInput sortOrder={sortOrder} setSortOrder={setSortOrder} />
        </div>

        <div className="package-list-add-btn" onClick={handleOpen}>
          <div>{t("NewPackage")}</div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M20 11.4286H11.4286V20H8.57143V11.4286H0V8.57143H8.57143V0H11.4286V8.57143H20V11.4286Z"
              fill="white"
            />
          </svg>
        </div>
      </div>

      {isLoading ? (
        <div className="loading-container">
          <SpinnerLoading />
        </div>
      ) : apiError ? (
        // Show API error
        <NotFound
          errorCode={errorData.code}
          errorMessage={errorData.message}
          description={errorData.description}
        />
      ) : data && data.length !== 0 ? (
        // Show package list
        <>
          {data.map((item, index) => (
            <Package
              key={item.name}
              id={item.name}
              image={require("../../../../assets/images/packages/HE 1.png")}
              title={item.package_name}
              cities={item.destinations}
              startDate={item.start_date}
              endDate={item.end_date}
              status={item.quotation_status}
              price={item.base_grand_total}
              onClick={() => {
                setPackageData((prev) => ({
                  ...prev,
                  "package_name": item.name,
                }));
                goToDetails(item.name);
              }}
              onDelete={() => {
                setDeleteId(item.name);
                setDeleteModal(true);
              }}
            />
          ))}
        </>
      ) : (
        // Show no packages message
        <NotFound
          errorCode={"204"}
          errorMessage={t("NoData")}
          description={t("NoPackageAvailable")}
        />
      )}
      <div className="d-flex justify-content-center mt-5">
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      </div>

      <Modal
        show={open}
        onHide={handleClose}
        className={`planning-modal ${Lang === "ar" ? "rtl" : "ltr"}`}
      >
        <Modal.Header className="planning-modal-header">
          <Modal.Title className="planning-modal-title">
            {t("PackageInfo")}
          </Modal.Title>
          <div
            className="planning-modal-header-desc"
            dangerouslySetInnerHTML={{ __html: t("PackageInfoDescription") }}
          ></div>
        </Modal.Header>

        <Modal.Body className="planning-modal-body">
          <Form>
            <Form.Group className="mb-3" controlId="formPackageName">
              <Form.Label className="planning-modal-label">
                {t("PackageName")}
              </Form.Label>
              <Form.Control
                type="text"
                className="planning-modal-input"
                name="packageName"
                value={nameValue}
                // onChange={handleInputChange}
                onChange={(e) => setNameValue(e.target.value)}
                onBlur={handleBlur}
                ond
                placeholder={t("GivePackageName")}
              />

              {errors.packageName &&
                (packageData.packageName === "" ||
                  !packageData.packageName) && (
                  <div className="invalid-feedback">{errors.packageName}</div>
                )}
            </Form.Group>

            <Form.Group controlId="formCountries">
              <Form.Label className="planning-modal-label">
                {t("WhichCountries")}
              </Form.Label>

              <Autocomplete
                dir={Lang === "ar" ? "rtl" : "ltr"}
                multiple
                options={locations}
                className="country-dropdown"
                getOptionLabel={(option) => option.location_name || ""}
                value={packageData.countries}
                // onChange={(event, newValue) => handleCountrySelect(newValue)} //handleCountrySelect
                onChange={handleCountrySelect}
                onInputChange={(event, value) => {
                  fetchLocations(value);
                }}
                filterSelectedOptions
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => <></>)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={t("SelectCountries")}
                    size="small"
                    onKeyDown={(e) => {
                      if (
                        e.key === "Backspace" &&
                        e.target.value === "" &&
                        packageData.countries.length > 0
                      ) {
                        e.stopPropagation(); // prevent chip deletion
                      }
                    }}
                    InputProps={{
                      ...params.InputProps,
                      style: {
                        direction: Lang === "ar" ? "rtl" : "ltr",
                      },

                      sx: {
                        backgroundColor: "#FFF",
                        borderRadius: "6px",
                        border: `1px solid #E9ECEF`,
                        padding: "9px 15px !important",
                        fontFamily: '"Dmsans400"',
                        fontSize: "14px !important",
                        fontWeight: 400,
                        letterSpacing: "0.25px",
                                          },
                    }}
                  />
                )}
                slotProps={{
                popper: {
                    modifiers: [
                      {
                        name: 'zIndex',
                        enabled: true,
                        phase: 'beforeWrite',
                        fn: ({ state }) => {
                          state.styles.popper.zIndex = 4000;
                        },
                      },
                    ],
                    sx: {
                      zIndex: 4000, // For MUI v5 style support
                    },
                  },
                }}
                sx={{
                  width: "100%",
                  mt: 1,

                  ".MuiAutocomplete-inputRoot": {
                    fontSize: "12px",
                    flexDirection: Lang === "ar" ? "row-reverse" : "row",
                  },
                  ".MuiAutocomplete-endAdornment": {
                    left: Lang === "ar" ? "9 !important" : "unset !important",
                    right: Lang === "ar" ? "unset !important" : "9 !important",
                  },
                  ".MuiInputBase-input": {
                    textAlign: Lang === "ar" ? "right" : "left",
                  },
                }}
              />
              {errors.countries && packageData.countries.length === 0 && (
                <div className="invalid-feedback">{errors.countries}</div>
              )}

              <div
                className="modal-selected-countries"
                style={{
                  marginTop: `${
                    packageData.countries.length > 0 ? "25px" : ""
                  }`,
                }}
              >
                {packageData.countries && packageData.countries.length > 0 &&
                  packageData.countries.map((country) => (
                    <Chip
                      key={country.location_name}
                      label={country.location_name}
                      onDelete={() => handleDelete(country.name)}
                      variant="outlined"
                      sx={{
                        background: "rgba(37, 74, 165, 0.07)",
                        color: "#27346A",
                        fontSize: "14px",
                        fontFamily: "Dmsans400",
                        border: "unset",
                        direction: Lang === "ar" ? "rtl" : "ltr",

                        "& .MuiChip-deleteIcon": {
                          fill: "#27346A",
                          opacity: "0.26",
                          marginLeft: Lang === "ar" ? "6px" : "0",
                          marginRight: Lang !== "ar" ? "6px" : "0",
                        },
                      }}
                    />
                  ))}
              </div>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formTravelers">
              <Form.Label className="planning-modal-label">
                {t("NumberOfTravelers")}
              </Form.Label>
              <TravelerSelector
                adults={packageData.travelers.adults}
                children={packageData.travelers.children}
                childrenAges={packageData.travelers.children_ages}
                infants={packageData.travelers.infants}
                onAdultsChange={(newAdults) =>
                  setPackageData((prev) => ({
                    ...prev,
                    travelers: {
                      ...prev.travelers,
                      adults: newAdults,
                    },
                  }))
                }
                onChildrenChange={(newChildren) =>
                  setPackageData((prev) => ({
                    ...prev,
                    travelers: {
                      ...prev.travelers,
                      children: newChildren,
                    },
                  }))
                }
                // onInfantsChange={(newInfants) =>
                //   setPackageData((prev) => ({
                //     ...prev,
                //     travelers: {
                //       ...prev.travelers,
                //       infants: newInfants,
                //     },
                //   }))
                // }
                onChildrenAgesChange={(newAges) =>
                  setPackageData((prev) => ({
                    ...prev,
                    travelers: {
                      ...prev.travelers,
                      children_ages: newAges,
                    },
                  }))
                }
              />
              {errors.childrenAges &&
                (packageData.travelers.children_ages.includes(null) ||
                  packageData.travelers.children_ages.includes(0)) && (
                  <div className="invalid-feedback">{errors.childrenAges}</div>
                )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formDates">
              <Form.Label className="planning-modal-label">
                {t("TravelDate")}
              </Form.Label>
              <DateRangePicker
                // value={
                //     packageData.startDate && packageData.endDate
                //         ? [new Date(packageData.startDate), new Date(packageData.endDate)]
                //         : null
                // }
                onChange={({ startDate, endDate }) => {
                  setPackageData((prev) => ({
                    ...prev,
                    startDate,
                    endDate,
                  }));
                }}
                min={new Date()}
              />
              {errors.date &&
                packageData.startDate === "" &&
                !packageData.startDate &&
                packageData.endDate === "" &&
                !packageData.endDate && (
                  <div className="invalid-feedback">{errors.date}</div>
                )}
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer className="planning-modal-footer">
          <button
            className={`planning-modal-btn ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={(e) => {
              if (!loading) {
                handleSubmit(e);
              }
            }}
            disabled={loading}
          >
            {loading ? t("Loading") + "..." : t("StartPlanning")}
          </button>
        </Modal.Footer>
      </Modal>
      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />

      <ComingSoon show={showModal} onClose={() => setShowModal(false)} />
      <GlobalModal
        title={t("RemovePackage")}
        subtitle={t("ConfirmationRemove")}
        globalModal={deleteModal}
        onClick={() => {
          deletePackage(deleteId);
        }}
        onClose={() => {
          setDeleteModal(false);
          setDeleteId(null);
        }}
      ></GlobalModal>
            <ToastContainer
              position="bottom-right"
              hideProgressBar="true"
              type="error"
            /> 
    </div>
  );
};

export default PackageList;
